import { useCallback } from 'react';

import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Switch } from 'shared/mui/Switch';
import { Tooltip } from 'shared/mui/Tooltip';
import { Mapping } from 'types/embedded/gatewayRule';

import { GatewayRuleMappingToggleConfirm } from './GatewayRuleMappingToggleConfirm';
import { useChangeMappingActivity } from './hooks/useChangeMappingActivity';

export function GatewayRuleMappingMethodSwitch(): JSX.Element {
  const translate = useTypedTranslate();

  const record = useRecordContext<Mapping>();
  const { handleOpenRecordModal, handleCloseRecordModal, openRecordModal } = useRecordModal();

  const { changeMappingActivityMutation } = useChangeMappingActivity();

  const toggleMappingActive = useCallback(() => {
    handleOpenRecordModal(record);
  }, [record]);

  const onConfirm = useCallback(() => {
    record && changeMappingActivityMutation.mutate({ id: record?.id, active: !record?.active });
  }, [record?.active, record]);

  return (
    <>
      <GatewayRuleMappingToggleConfirm
        onClose={handleCloseRecordModal}
        onConfirm={onConfirm}
        open={openRecordModal}
      />
      <Tooltip
        arrow
        placement="top"
        title={
          record?.active
            ? translate('app.gatewayRules.mappingIsActive')
            : translate('app.gatewayRules.mappingIsInactive')
        }
      >
        <Switch checked={record?.active} onChange={toggleMappingActive} />
      </Tooltip>
    </>
  );
}
